import { render, staticRenderFns } from "./addPage.vue?vue&type=template&id=36092886&scoped=true"
import script from "./addPage.vue?vue&type=script&lang=js"
export * from "./addPage.vue?vue&type=script&lang=js"
import style0 from "./addPage.vue?vue&type=style&index=0&id=36092886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36092886",
  null
  
)

export default component.exports